import { render, staticRenderFns } from "./birthdays-week.vue?vue&type=template&id=bd516c66&scoped=true"
import script from "./birthdays-week.vue?vue&type=script&lang=js"
export * from "./birthdays-week.vue?vue&type=script&lang=js"
import style0 from "./birthdays-week.vue?vue&type=style&index=0&id=bd516c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd516c66",
  null
  
)

export default component.exports